import i18next from 'i18next'
import i18nextHttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import isFeatureEnabled, { FEATURES } from 'src/utils/isFeatureEnabled'

export const KEYSEP = '__.__'
export const NSSEP = '__:__'
export const PLURSEP = '_____'
export const CTXSEP = '_____'

const defaultOptions = new i18nextHttpBackend().options

const options = {
    lookupLocalStorage: 'i18nextLngHorizon',
    lookupSessionStorage: 'i18nextLngHorizon',
    debug: false,
    ns: ['common'],
    fallbackLng: false,
    defaultNS: 'common',
    load: 'languageOnly',
    backend: {
        // load from i18next-gitbook repo
        loadPath: '/api/translation/translation/{{lng}}/{{ns}}.json',
        crossDomain: false,
        addPath: '/api/translation/translation/{{lng}}/{{ns}}',
        request: function (options, url, payload, callback) {
            const isEnglish = url.match(/\/en(-..)*\//)
            if (isEnglish) {
                callback(null, { status: 200, data: '{}' })
            } else {
                defaultOptions.request(...arguments)
            }
        },
    },
    nsSeparator: NSSEP,
    pluralSeparator: PLURSEP,
    contextSeparator: CTXSEP,
    keySeparator: KEYSEP,
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    saveMissing: true,
    /*missingKeyHandler: (lngs, ns, key, fallbackValue, updateMissing, options) => {
            console.log(lngs, ns, key, fallbackValue, updateMissing, options)
        }*/
}

if (
    typeof localStorage !== 'undefined' &&
    (!isFeatureEnabled(FEATURES.TRANSLATIONS) ||
        !localStorage.getItem('i18nextLngHorizon'))
) {
    localStorage.setItem('i18nextLngHorizon', 'en')
    options.lng = 'en'
}

if (
    typeof localStorage !== 'undefined' &&
    isFeatureEnabled(FEATURES.TRANSLATIONS) &&
    localStorage.getItem('i18nextLngHorizon')
) {
    options.lng = localStorage.getItem('i18nextLngHorizon')
}

export default i18next
    .use(i18nextHttpBackend)
    .use(initReactI18next)
    .init(options)
